<template>
	<view class="paging">
		<view class="hint-group">
			<view class="hint"> 共{{pageCount}}页</view>
			<view class="hint"> 第{{thePage+1}}页</view>
		</view>
		<view class="btn-group">
			<view class="box" @click="toHomePage">首页</view>
			<view class="box" @click="toUpPage">上页</view>
			<view class="box" @click="toNextPage">下页</view>
			<view class="box" @click="toTrailPage">尾页</view>
		</view>
	</view>
</template>

<script>
	export default {
		name:"paging",
		props:{
			sumCount:0,
			onePageCount:0
		},
		data() {
			return {
				thePage : 0,
				pageCount:0,
			};
		},
		methods:{
			toHomePage(){
				this.thePage = 0;
				this.setIndex();
			},
			toTrailPage(){
				this.thePage = this.pageCount-1;
				this.setIndex();
			},
			toNextPage(){
				if(this.thePage<this.pageCount-1){
					this.thePage = this.thePage+1;
					this.setIndex();
				}
			},
			toUpPage(){
				if(this.thePage>0){
					this.thePage = this.thePage-1;
					this.setIndex();
				}
			},
			setIndex(){
				this.$emit("setIndex",this.thePage)
			}
		},
		created() {
			this.pageCount = Math.ceil(this.sumCount/this.onePageCount);
		}
	}
</script>

<style lang="scss" scoped>
	.paging{
		width: 300px;
		margin-bottom: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 1.4ch;

		.hint-group{
			display: flex;
			.hint{
				margin: 0 8px;
			}
		}
		.btn-group{
			display: flex;
			.box{
				margin: 0 4px;
				padding: 2px;
				width: 36px;
				text-align: center;
				color: #aaa;
				border: 1px #666 solid;
			}
			.box:hover{
				color: black;
				background-color: white;
				cursor: pointer;
			}
		}
	}
</style>